import {transformImage} from "../../../utils/StoryblokService";
import Image from "next/image";
import {IProjectItem} from "../../../types/IProjectItem";
import classNames from "classnames";
import {useStoryblokApi} from "@storyblok/react";
import {StarIcon} from "@heroicons/react/20/solid";
import {richTextResolver} from "@storyblok/richtext";

export default function ProjectQuote({item}: { item: IProjectItem }) {
    const { render } = richTextResolver()

    let quoteAuthorImage = item.content.client_image?.filename ? transformImage(item.content.client_image.filename, "200x0") : "/images/unknown_user.png";

    if (item.content.is_comment) {
        quoteAuthorImage = '/images/ceo_inset.webp';

    }

    return <blockquote className="relative rounded-lg bg-white shadow-lg my-12">
        <div className="rounded-t-lg px-6 py-8 sm:px-10 sm:pt-10 sm:pb-8">

            <div className={'flex gap-2'}>
            <span className={'bg-secondary text-white p-2 text-xs inline-block'}>
                {item.content.is_comment ? 'COMMENT' : 'CLIENT TESTIMONIAL'}
                </span>

                {!item.content.is_comment &&
                <div className={'text-yellow-400 ml-auto'}>
                    <StarIcon className={'inline-block h-5 w-5'}/>
                    <StarIcon className={'inline-block h-5 w-5'}/>
                    <StarIcon className={'inline-block h-5 w-5'}/>
                    <StarIcon className={'inline-block h-5 w-5'}/>
                    <StarIcon className={'inline-block h-5 w-5'}/>
                </div>}
            </div>

            <div className="relative mt-8 text-lg font-light text-gray-700">
                <svg
                    className="absolute top-0 left-0 h-8 w-8 -translate-x-3 -translate-y-2 transform text-gray-200 opacity-25"
                    fill="currentColor"
                    viewBox="0 0 32 32"
                    aria-hidden="true"
                >
                    <path
                        d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z"/>
                </svg>

                <div className={'grid grid-cols-3 gap-2 items-center'}>
                    <div className={classNames(
                        "relative",
                        (item.content.client_logo && item.content.client_logo.filename) ? 'col-span-2' : 'col-span-3'
                    )}>
                        <div dangerouslySetInnerHTML={{
                            __html: render(item.content.client_review) as string
                        }}/>
                    </div>
                    {item.content.client_logo && item.content.client_logo.filename &&
                        <div className={'col-span-1'}>

                            <div className={'h-12 w-auto relative'}>
                                <Image
                                    className="block ml-auto shrink-0 grow-0 object-contain"
                                    fill
                                    src={transformImage(item.content.client_logo.filename, "400x0")}
                                    alt="Logo"
                                />
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>


        <cite
            className="relative flex items-center rounded-b-lg bg-primary py-5 px-6 not-italic sm:mt-10 sm:items-start sm:py-5 sm:pl-12 sm:pr-10">

            <span
                className="relative rounded-full border-2 border-white sm:absolute sm:top-0 sm:-translate-y-1/2 sm:transform shrink-0">
                  <Image
                      className="h-12 w-12 rounded-full bg-white sm:h-20 sm:w-20 object-cover"
                      src={quoteAuthorImage}
                      width={250}
                      height={250}
                      alt=""
                  />
                </span>
            <span
                className={"relative font-semibold leading-6 text-secondary pl-1 " + ((true) ? 'sm:ml-24' : '')}>

                  <span className="font-semibold text-white sm:inline">
                      {!item.content.is_comment && item.content.show_client_review_name &&
                          <span>{item.content.client_review_name}</span>}
                      {!item.content.show_client_review_name && !item.content.is_comment &&
                          <span>Anonymous Client</span>}
                      {item.content.is_comment && <span>Christoph Heike</span>}

                  </span>{' '}

                {item.content.is_comment && <span className="sm:inline"> -{' '}
                    <span>CEO at Pacific Codeline LLC</span>
                </span>}

                {!item.content.is_comment && item.content.show_client_company && item.content.client &&
                    <span className="sm:inline"> -{' '}
                        <span>{item.content.client}</span>
                </span>}
                </span>
        </cite>
    </blockquote>

}